import angular from "angular";
import ForecastDataCtrl from "./ForecastDataCtrl";
import ForecastDataService from "./ForecastDataService";

export default angular
  .module("energis.ForecastData", [])
  .config(function routes($stateProvider) {
    $stateProvider.state("forecast-data", {
      url: "/forecast/data",
      template: require("./forecast-data.html"),
      controller: ForecastDataCtrl,
      controllerAs: "ctrl",
      resolve: {
        //itemSource: (ForecastDataService) => ForecastDataService.getOPM()
      }
    });
  })
.service("ForecastDataService", ForecastDataService).name;



// WEBPACK FOOTER //
// ./src/ForecastData/index.js